import { mediaQueryAsync } from 'helpers/graphql'
import { fetchSourceGroupSuccess } from './actions';

// export const fetchSourceGroup = () => {
//   const {access_token} = localStorage;
//   return request.get(config.media.baseUrl + '/source_groups')
//     .query({
//       access_token,
//     })
//     .endAsync()
//     .get('body')
//     .then(fetchSourceGroupSuccess);
// }

export const fetchSourceGroup = (data) => {
  const query = `
    query(
      $offset: Int
      $ids: [ID]
      $mediaType:String
      $name: String
      $label: String
    ) {
      sourceGroups(
        limit: 999
        offset: $offset
        ids: $ids
        mediaType: $mediaType
        name: $name
        label: $label
      ) {
        count
        data {
          id
          name
          mediaType
          description
          sources
          labels
        }
      }
    }
  `
  return mediaQueryAsync(query, data)
  .then((body) =>
    fetchSourceGroupSuccess(body.data.sourceGroups.data)
  );
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/sourceGroup/tasks.js
 **/